import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('fluid-pay', (editor, opts) => {
  const default_types = {
    fluid: 'fluid_pay',
  };
  const default_labels = {
    fluid: 'Fluid Pay',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
    },
    ...opts,
  };
  loadComponents(editor, options);
});
